import { render, staticRenderFns } from "./TopluIslemComponent.vue?vue&type=template&id=0742c885"
import script from "./TopluIslemComponent.vue?vue&type=script&lang=js"
export * from "./TopluIslemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports